import { render, staticRenderFns } from "./createCatalogueButton.vue?vue&type=template&id=77ec1557&"
import script from "./createCatalogueButton.vue?vue&type=script&lang=js&"
export * from "./createCatalogueButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports